import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';

import useAboutStyles, { ONE_COL } from './aboutStyles';
import { cx } from '../Home/HomeDashboard/dashboardStyles';
import { REDESIGN_TINTS } from '../../constants';

const IMG = '/static/asset/img/';

// The mission in two chapters, each a run of paragraph/picture rows.
const CHAPTERS = [
    {
        key: 'start',
        kickerId: 'redesign.about.mission.chapter1',
        titleId: 'aboutUs.ourMission.start',
        rows: [
            { texts: ['aboutUs.ourMission.startDescription.1'], img: `${IMG}pandemic.webp`, tint: REDESIGN_TINTS.mint },
            {
                texts: ['aboutUs.ourMission.startDescription.2', 'aboutUs.ourMission.startDescription.3'],
                img: `${IMG}feedback.webp`,
                tint: REDESIGN_TINTS.peach,
            },
        ],
    },
    {
        key: 'now',
        kickerId: 'redesign.about.mission.chapter2',
        titleId: 'aboutUs.ourMission.now',
        rows: [
            { texts: ['aboutUs.ourMission.nowDescription.1'], img: `${IMG}digital-education.webp`, tint: REDESIGN_TINTS.sky },
            { texts: ['aboutUs.ourMission.nowDescription.2'], img: `${IMG}online-teach.webp`, tint: REDESIGN_TINTS.amber },
            { texts: ['aboutUs.ourMission.nowDescription.3'], img: `${IMG}stock-digital-board.webp`, tint: REDESIGN_TINTS.periwinkle },
        ],
    },
];

// The mission's paragraphs are short, so the pictures stay small beside them
// rather than filling a full column.
const useStyles = makeStyles(() => ({
    row: {
        gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 340px)',
        marginTop: '22px',
        [ONE_COL]: {
            gridTemplateColumns: 'minmax(0, 1fr)',
        },
    },
    rowFlipped: {
        gridTemplateColumns: 'minmax(0, 340px) minmax(0, 1fr)',
        [ONE_COL]: {
            gridTemplateColumns: 'minmax(0, 1fr)',
        },
    },
    photo: {
        aspectRatio: '16 / 10',
    },
}));

const AboutHome = () => {
    const classes = useAboutStyles();
    const own = useStyles();

    return (
        <>
            <div className={classes.head}>
                <h2 className={classes.h2}>
                    <FormattedMessage id="aboutUs.ourMission.button" />
                </h2>
                <p className={classes.lead}>
                    <FormattedMessage id="redesign.about.mission.lead" />
                </p>
            </div>

            {CHAPTERS.map((chapter) => (
                <React.Fragment key={chapter.key}>
                    <div className={classes.kickerRow}>
                        <span className={classes.kicker}>
                            <FormattedMessage id={chapter.kickerId} />
                        </span>
                        <span aria-hidden="true" className={classes.kickerRule} />
                    </div>
                    <div className={classes.card}>
                        <h3 className={classes.h3}>
                            <FormattedMessage id={chapter.titleId} />
                        </h3>
                        {chapter.rows.map((row, index) => (
                            <div
                                key={row.img}
                                className={cx(
                                    classes.row,
                                    own.row,
                                    index % 2 === 1 && classes.rowFlipped,
                                    index % 2 === 1 && own.rowFlipped
                                )}
                            >
                                <div>
                                    {row.texts.map((id) => (
                                        <p key={id} className={classes.text}>
                                            <FormattedMessage id={id} />
                                        </p>
                                    ))}
                                </div>
                                <div className={classes.mat} style={{ background: row.tint }}>
                                    <img src={row.img} alt="" loading="lazy" decoding="async" className={cx(classes.photo, own.photo)} />
                                </div>
                            </div>
                        ))}
                    </div>
                </React.Fragment>
            ))}
        </>
    );
};

export default AboutHome;
